import React from "react"
import { Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import { Link } from "react-router"
import Authenticated from "../../lib/Authenticated"

export default function AccountingMenu() {

  const authenticated = new Authenticated(),
  isAdmin = authenticated.isAdmin()

  const renderItem = (url, title, icon, desc, disabled) => 
    <ListGroupItem className="menu-link-item" disabled={ disabled }>

      { !disabled ?
      <Link to={ url } className='m-10'>
        <FontAwesome name={ icon } /> &nbsp;
        <strong> { title }</strong><br/>
        <span className="mt-5 display-block">{ desc }</span>
      </Link>
      : <span className='m-10 display-block' title="Item disabled">
          <FontAwesome name={ icon } /> &nbsp;
          <strong> { title }</strong><br/>
          <span className="mt-5 display-block">{ desc }</span>
        </span> 
      }
    </ListGroupItem>

  return (
    <Row>
      <Col md={6}>
        <ListGroup>
          { renderItem('/glaccounts', 'GL Accounts', 'sitemap', 'GL accounts used by the organization') }
          { renderItem('/journalentries', 'Journal Entries', 'random', 'Manual journal entry transactions recorded in a journal') }
        </ListGroup>
      </Col>

      { isAdmin &&
      <Col md={6}>
        <ListGroup>
          { renderItem('/glclosures', 'Closing Entries', 'folder', 'Journal entries made at the end of an accounting period') }
          { renderItem('/accountingrules', 'Accounting Rules', 'lock', 'Accounting rules of the organization') }
        </ListGroup>
      </Col>
      }

      { isAdmin &&
      <Col md={6}>
        <ListGroup>
          { renderItem('/loanaccounting', 'Loan Accounting', 'square-o', 'Loan integration with Accounting', true) }
          { renderItem('/loancommission', 'Loan Commissions', 'tags', 'Configure commissions for loans') }
        </ListGroup>
      </Col>
      }

      { isAdmin &&
      <Col md={6}>
        <ListGroup>
          { renderItem('/customaccounting', 'Custom Loan Accounting', 'crosshairs', 'Custom Loan integration with Accounting') }
          { renderItem('/extraaccounting', 'Extra Loan Accounting', 'cube', ' Extra configuration for Accounting') }
        </ListGroup>
      </Col>
      }

      { isAdmin &&
      <Col md={6}>
        <ListGroup>
          { renderItem('/defaultedloanaccounting', 'Accounting for Defaulted Loans', 'magic', 'Configure Accounting for defaulted loans') }
          {/* { renderItem('/vataccountingrule', 'Accounting for Bundle VATs', 'sticky-note-o', 'Configure Accounting for Bundle VATs') } */}
        </ListGroup>
      </Col>
      }
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingMenu.js